var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.5,
    height: 20,
    rx: 4,
    fill: "#61A578"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08984 6.63672L6.54102 14.0312H5L8.21094 5.5H9.19531L9.08984 6.63672ZM11.2227 14.0312L8.66797 6.63672L8.55664 5.5H9.54688L12.7695 14.0312H11.2227ZM11.0996 10.8672V12.0332H6.45898V10.8672H11.0996Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.293 5.5L13.9707 14.7637H12.8633L16.1914 5.5H17.293Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6113 10.1758H19.4375L19.4258 9.10352H21.3242C21.6445 9.10352 21.916 9.05664 22.1387 8.96289C22.3652 8.86523 22.5371 8.72656 22.6543 8.54688C22.7715 8.36328 22.8301 8.14258 22.8301 7.88477C22.8301 7.59961 22.7754 7.36719 22.666 7.1875C22.5566 7.00781 22.3887 6.87695 22.1621 6.79492C21.9395 6.71289 21.6543 6.67188 21.3066 6.67188H19.8828V14.0312H18.4121V5.5H21.3066C21.7754 5.5 22.1934 5.54492 22.5605 5.63477C22.9316 5.72461 23.2461 5.86523 23.5039 6.05664C23.7656 6.24414 23.9629 6.48242 24.0957 6.77148C24.2324 7.06055 24.3008 7.4043 24.3008 7.80273C24.3008 8.1543 24.2168 8.47656 24.0488 8.76953C23.8809 9.05859 23.6328 9.29492 23.3047 9.47852C22.9766 9.66211 22.5684 9.77148 22.0801 9.80664L21.6113 10.1758ZM21.5469 14.0312H18.9746L19.6367 12.8652H21.5469C21.8789 12.8652 22.1562 12.8105 22.3789 12.7012C22.6016 12.5879 22.7676 12.4336 22.877 12.2383C22.9902 12.0391 23.0469 11.8066 23.0469 11.541C23.0469 11.2637 22.998 11.0234 22.9004 10.8203C22.8027 10.6133 22.6484 10.4551 22.4375 10.3457C22.2266 10.2324 21.9512 10.1758 21.6113 10.1758H19.959L19.9707 9.10352H22.1211L22.4551 9.50781C22.9238 9.52344 23.3086 9.62695 23.6094 9.81836C23.9141 10.0098 24.1406 10.2578 24.2891 10.5625C24.4375 10.8672 24.5117 11.1953 24.5117 11.5469C24.5117 12.0898 24.3926 12.5449 24.1543 12.9121C23.9199 13.2793 23.582 13.5586 23.1406 13.75C22.6992 13.9375 22.168 14.0312 21.5469 14.0312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbActive);
export default __webpack_public_path__ + "static/media/ab_active.d66bfcc1b4eb5a7ce622d1d9cf0d09c9.svg";
export { ForwardRef as ReactComponent };